module.exports = __webpack_public_path__ + "img/logo-center.f376ff2d.png";